import { UseFormRegister } from 'react-hook-form'
import { test, enforce, create } from 'vest'
import { IVictimDTO, ISubjectDTO } from '../../../store/users/types'
import TextareaInput from '../../TextareaInput'
import constants from './constants'
import { personTypes } from './types'

const newTagFormValidation = create((data = {}) => {
  const { newTag } = data

  test('newTag', 'You must enter the Name', () => {
    enforce(newTag).isNotEmpty()
  })
})

const camalize = (str: string) => {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase())
}

const getDefaultValues = (
  personType: personTypes,
  defaultValue: IVictimDTO | ISubjectDTO | undefined,
) => {
  if (!defaultValue) return constants.getDefaulfFormValues(personType)

  if (personType === 'victim') {
    const test = defaultValue as IVictimDTO
    return {
      ...test,
      victim: { ...test.victim },
    }
  }
  const test = defaultValue as ISubjectDTO
  return {
    ...test,
    subject: { ...test.subject },
  }
}
const convertImageToFiles = async (imageUrl: string) => {
  const response = await fetch(imageUrl)
  const blob = await response.blob()
  return new File([blob], 'profileImage.png')
}

const renderCustomFields = (customFields: any, register: UseFormRegister<any>) => {
  return (
    customFields &&
    Object.keys(customFields).map(key => {
      return (
        <TextareaInput
          label={key}
          key={key}
          register={register}
          fieldName={key}
          minRows={5}
          placeholder={'Write a brief message'}
        />
      )
    })
  )
}

export default {
  camalize,
  newTagFormValidation,
  getDefaultValues,
  convertImageToFiles,
  renderCustomFields,
}
